import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  productAdd,
  productsGetByGTIN,
  productsGetByMPN,
  productsLoadAll,
  productsLoadAllShort,
  productsLoadByBrand,
  productsLoadByCategory,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(productAdd.type, send, socket);
  yield takeEvery(productsGetByGTIN.type, send, socket);
  yield takeEvery(productsGetByMPN.type, send, socket);
  yield takeEvery(productsLoadAllShort.type, send, socket);
  yield takeEvery(productsLoadAll.type, send, socket);
  yield takeEvery(productsLoadByBrand.type, send, socket);
  yield takeEvery(productsLoadByCategory.type, send, socket);
}
